<template>
    <div class="basic_wrap">
		<div class="lan-box">
			<van-popover
			  v-model="showPopover"
			  trigger="click"
			  placement="bottom-start"
			  :offset="[0, 0]"
			  :actions="actions"
			  @select="onSelect"
			>
			  <template #reference>
				<div class="lan-label">
					<img :src="lan_ico" alt="">
					<span >{{lan_num}}</span>
				</div>
			  </template>
			</van-popover>
		</div>
		<div class="user-top">
			<img src="../images/login/logo.png" alt="">
			<div class="user-name">B2B</div>
		</div>
		<div class="login-main">
        <form class="form">
            <div class="cut_login">
                <router-link class="cur" to="/login"
                    >{{$t('login.signIn')}}
                    <div class="line"></div>
                </router-link>
                <router-link to="/register"
                    >{{$t('login.signUp')}}
                    <div class="line"></div>
                </router-link>
            </div>
            <div class="reg-type-switch">
                <div :class="['reg-type-item', loginType === 'email' ? 'active' : '']" @click="loginType = 'email'">
                    {{$t('login.loginTypeEmail')}}
                </div>
                <div :class="['reg-type-item', loginType === 'phone' ? 'active' : '']" @click="loginType = 'phone'">
                    {{$t('login.loginTypePhone')}}
                </div>
            </div>
            <div v-if="loginType === 'email'" class="item mt" style="padding-left: 10px;">
				<span class="icon"
				    ><img src="../images/login/email.png" alt=""
				/></span>
                <input
                    type="text"
                    class="inp"
                    v-model.trim="data.username"
                    :placeholder="$t('login.phoneNumber')"
                />
            </div>
            <div v-if="loginType === 'phone'" class="item mt phone-item">
                <div class="country-code-btn" @click="showCountryPicker = true">
                    <span class="country-flag">{{ selectedCountry.flag }}</span>
                    <span class="country-dial">{{ selectedCountry.code }}</span>
                    <span class="arrow-down">▾</span>
                </div>
                <div class="divider-line"></div>
                <input v-model.trim="phoneNum" type="tel" class="inp" :placeholder="$t('login.phoneInput')">
            </div>
            <div class="item" style="padding-left: 10px;">
                <span class="icon"
                    ><img src="../images/login/lock.png" alt=""
                /></span>
                <input
                    :type="password"
                    class="inp"
                    v-model.trim="data.password"
                    :placeholder="$t('login.password')"
                />
                <div
                    class="eye_bi"
                    @click="showPwd"
                    :class="password == 'text' ? 'eye' : ''"
                ></div>
            </div>
			<div
			    type="submit"
			    class="basic_btn sbtn"
			    :class="submitDisabled ? 'no_touch' : ''"
			    @click="submit"
			>
			    {{$t('login.signInBtn')}}
			</div>
            <div class="item_reset_pwd">
				<van-checkbox v-model="checked" shape="square" icon-size="14px">{{$t('login.remember')}}</van-checkbox>
                <router-link class="reset_pwd" to="/forgetpwd">{{$t('login.forget')}}</router-link>
            </div>
        </form>
        </div>
        <div
            v-if="msg_show"
            class="kefu-link"
            :class="show_kefu ? '' : 'kefu_hide'"
            @click="kefu_to"
        >
            <img class="kefu_img" src="../../views/images/user/kefu-ico.png" />
        </div>

        <van-popup v-model="showCountryPicker" position="bottom" class="country-popup">
            <div class="country-picker-header">
                <span>{{ $t('register.selectCountry') }}</span>
                <span class="cp-close" @click="showCountryPicker = false">✕</span>
            </div>
            <div class="country-search">
                <input
                    v-model="searchQuery"
                    type="text"
                    class="country-search-input"
                    :placeholder="$t('register.searchCountry')"
                >
            </div>
            <div class="country-list">
                <div
                    v-for="(item, index) in filteredCountries"
                    :key="index"
                    class="country-item"
                    :class="{ 'country-item--active': selectedCountry.code === item.code }"
                    @click="onCountryConfirm(item)"
                >
                    <span class="ci-flag">{{ item.flag }}</span>
                    <span class="ci-name">{{ item.name }}</span>
                    <span class="ci-code">{{ item.code }}</span>
                    <span v-if="selectedCountry.code === item.code" class="ci-check">✓</span>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import Vue from 'vue'
import Fetch from "../../utils/fetch"
import {CountDown, Checkbox, Popover, Popup} from 'vant'
Vue.use(Checkbox)
Vue.use(Popover)
Vue.use(Popup)

const COUNTRIES = [
	{ flag: '🇨🇳', name: '中国', code: '+86' },
	{ flag: '🇭🇰', name: '香港', code: '+852' },
	{ flag: '🇹🇼', name: '台灣', code: '+886' },
	{ flag: '🇺🇸', name: 'United States', code: '+1' },
	{ flag: '🇬🇧', name: 'United Kingdom', code: '+44' },
	{ flag: '🇦🇺', name: 'Australia', code: '+61' },
	{ flag: '🇸🇬', name: 'Singapore', code: '+65' },
	{ flag: '🇯🇵', name: '日本', code: '+81' },
	{ flag: '🇰🇷', name: '한국', code: '+82' },
	{ flag: '🇹🇭', name: 'ประเทศไทย', code: '+66' },
	{ flag: '🇲🇾', name: 'Malaysia', code: '+60' },
	{ flag: '🇻🇳', name: 'Việt Nam', code: '+84' },
	{ flag: '🇧🇷', name: 'Brasil', code: '+55' },
	{ flag: '🇵🇭', name: 'Pilipinas', code: '+63' },
	{ flag: '🇮🇩', name: 'Indonesia', code: '+62' },
	{ flag: '🇮🇳', name: 'भारत', code: '+91' },
	{ flag: '🇫🇷', name: 'France', code: '+33' },
	{ flag: '🇮🇹', name: 'Italia', code: '+39' },
	{ flag: '🇸🇦', name: 'السعودية', code: '+966' },
	{ flag: '🇦🇪', name: 'الإمارات', code: '+971' },
	{ flag: '🇪🇬', name: 'مصر', code: '+20' },
	{ flag: '🇰🇼', name: 'الكويت', code: '+965' },
	{ flag: '🇶🇦', name: 'قطر', code: '+974' },
];

export default {
    name: "login",
    data() {
        return {
			lang: this.$i18n.locale || "en_us",
            password: "password",
            show_kefu: false,
            msg_show: true,
			checked: true,
			showPopover: false,
            loginType: 'email',
            phoneNum: '',
            showCountryPicker: false,
            searchQuery: '',
            selectedCountry: COUNTRIES.find(c => c.code === '+1'),
			actions: [
				{ text: '中国', icon: require('../images/language/zh_cn.png') },
				{ text: 'English', icon: require('../images/language/en_us.png') },
				{ text: '日本', icon: require('../images/language/ja_jp.png') },
				{ text: '한국어', icon: require('../images/language/ko_kr.png') },
				{ text: 'Việt Nam', icon: require('../images/language/vi_vn.png') },
				{ text: 'ภาษาไทย', icon: require('../images/language/th_th.png') },
				{ text: 'Malaysia', icon: require('../images/language/ms_my.png') },
				{ text: '繁體中文', icon: require('../images/language/zh_hk.png') },
				{ text: 'Deutsch', icon: require('../images/language/de_de.svg') },
				{ text: 'Español', icon: require('../images/language/es_es.svg') },
				{ text: 'Português (BR)', icon: require('../images/language/pt_br.svg') },
				{ text: 'العربية', icon: require('../images/language/ar_sa.svg') },
				{ text: 'Italiano', icon: require('../images/language/it_it.svg') },
				{ text: 'Français', icon: require('../images/language/fr_fr.svg') },
				{ text: 'Indonesia', icon: require('../images/language/id_id.svg') },
				{ text: 'हिन्दी', icon: require('../images/language/hi_in.svg') },
			],
			lan_num: 'English',
			lan_ico: require('../images/language/en_us.png'),
            data: {
                username: "",
                password: "",
            },
			show_ver: false,
        };
    },
    computed: {
        submitDisabled() {
            if (this.loginType === 'phone') {
                return !this.phoneNum || !this.data.password;
            }
            return !this.data.username || !this.data.password;
        },
        filteredCountries() {
            if (!this.searchQuery) return COUNTRIES;
            const q = this.searchQuery.toLowerCase();
            return COUNTRIES.filter(c =>
                c.name.toLowerCase().includes(q) || c.code.includes(q)
            );
        }
    },
    created() {
		this.data.username = localStorage.getItem('login_username');
		this.data.password = localStorage.getItem('login_password');
		const locale = localStorage.getItem("lang") || "en_us";
		const langMap = {"中国":"zh_cn","English":"en_us","日本":"ja_jp","한국어":"ko_kr","Việt Nam":"vi_vn","ภาษาไทย":"th_th","Malaysia":"ms_my","繁體中文":"zh_hk","Deutsch":"de_de","Español":"es_es","Português (BR)":"pt_br","العربية":"ar_sa","Italiano":"it_it","Français":"fr_fr","Indonesia":"id_id","हिन्दी":"hi_in"};
		const matched = this.actions.find(a => langMap[a.text] === locale);
		if (matched) { this.lan_num = matched.text; this.lan_ico = matched.icon; }
        this.$parent.footer("user", false);
    },
    mounted() {
        var that = this;
        document.body.addEventListener(
            "scroll",
            function() {
                if (!that.show_kefu) {
                    return;
                }
                that.show_kefu = false;
            },
            false
        );
        document.addEventListener(
            "click",
            function(ev) {
                if (ev.target.className != "kefu_img") {
                    that.show_kefu = false;
                }
            },
            false
        );
    },
    methods: {
        kefu_to() {
            this.$router.push("/kefu");
        },
        showPwd() {
            if (this.password == "password") {
                this.password = "text";
            } else {
                this.password = "password";
            }
        },
		onSelect(action) {
			this.lan_ico = action.icon
			this.lan_num = action.text
			let lang
			if (action.text == "中国") { lang = "zh_cn" }
			if (action.text == "English") { lang = "en_us" }
			if (action.text == "日本") { lang = "ja_jp" }
			if (action.text == "한국어") { lang = "ko_kr" }
			if (action.text == "Việt Nam") { lang = "vi_vn" }
			if (action.text == "ภาษาไทย") { lang = "th_th" }
			if (action.text == "Malaysia") { lang = "ms_my" }
			if (action.text == "繁體中文") { lang = "zh_hk" }
			if (action.text == "Deutsch") { lang = "de_de" }
			if (action.text == "Español") { lang = "es_es" }
			if (action.text == "Português (BR)") { lang = "pt_br" }
			if (action.text == "العربية") { lang = "ar_sa" }
			if (action.text == "Italiano") { lang = "it_it" }
			if (action.text == "Français") { lang = "fr_fr" }
			if (action.text == "Indonesia") { lang = "id_id" }
			if (action.text == "हिन्दी") { lang = "hi_in" }
			this.$i18n.locale = lang;
			localStorage.setItem("lang", lang);
		},
        onCountryConfirm(item) {
            this.selectedCountry = item;
            this.showCountryPicker = false;
            this.searchQuery = '';
        },
        submit() {
            let username;
            if (this.loginType === 'phone') {
                if (!this.phoneNum) {
                    this.$toast({
                        className: "toastName",
                        message: this.$t('login.phoneInputEmpty'),
                    });
                    return;
                }
                username = this.selectedCountry.code + this.phoneNum;
            } else {
                username = this.data.username;
                if (!username) {
                    this.$toast({
                        className: "toastName",
                        message: this.$t('login.phoneEmpty'),
                    });
                    return;
                }
            }

            if (!this.data.password) {
				this.$toast({
					className: "toastName",
					message: this.$t('login.passwordEmpty'),
				});
                return;
            }

			if (this.checked) {
				localStorage.setItem('login_username', username);
				localStorage.setItem('login_password', this.data.password);
			}
			if (!this.checked) {
				localStorage.removeItem('login_username');
				localStorage.removeItem('login_password');
			}

            Fetch("/index/login", {
                username: username,
                password: this.data.password
            })
                .then((res) => {
					if (res.data.token) {
					    localStorage.setItem('token', res.data.token);
					}
					this.$toast({
						className: "toastName",
						message: this.$t('login.signInSuccess'),
					});
                })
                .then(() => {
                    this.$router.replace({
                        path: this.$router.history.current.query.redirect || "/",
                    });
                });
        },
    },
};
</script>

<style lang="less" scoped>
	.user-top{
		text-align: center;
		padding: 90px 0 50px 0;
		color: #ffffff;
		img{
			width: 60px;
			height: 60px;
			border-radius: 60px;
			border: 2px solid #ffffff;
		}
		.user-name{
			font-size: 16px;
			margin-top: 10px;
		}
	}
	.basic_wrap{
		position: relative;
		background: url(../images/login/login_bg.png) no-repeat center top;
		background-size: contain;
		.lan-box{
			position: absolute;
			top: 10px;
			left:25px;
		}
	}

.login-main{
	padding: 0 25px;
}
.basic_wrap .form {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 9px 2px rgba(160, 160, 160, 0.15);
    border-radius: 13px;
    padding: 31px 24px 24px 24px;
}

.cut_login {
    width: 207px;
    line-height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    text-align: center;
    margin: 0 auto;

    a {
        width: 50%;
        padding-bottom: 10px;
        color: #ceced0;
        position: relative;

        .line {
            width: 100%;
            height: 1px;
            position: absolute;
            left: 0;
            bottom: 0;
            background-color: #f2f2f2;
        }
    }

    a.cur {
        color: #f12211;

        .line {
            height: 2px;
            background-image: linear-gradient(to right, #f12211, #f18a11);
        }
    }
}

.reg-type-switch {
    display: flex;
    align-items: center;
    margin: 16px 0 12px 0;
    background-color: #ebebeb;
    border-radius: 10px;
    padding: 4px;

    .reg-type-item {
        flex: 1;
        text-align: center;
        font-size: 14px;
        font-weight: 500;
        color: #333;
        padding: 10px 0;
        border-radius: 8px;
        cursor: pointer;
        transition: background 0.2s, color 0.2s, box-shadow 0.2s;

        &.active {
            color: #fff;
            font-weight: 700;
            background-image: linear-gradient(to right, #f12211, #f18a11);
            box-shadow: 0 2px 8px rgba(241, 34, 17, 0.35);
        }
    }
}

.mt {
    margin-top: 20px;
}

.item {
    height: 48px;
	padding: 0 15px;
    border: 1px solid #dfdfdf;
    font-size: 14px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
	margin-bottom: 15px;
    .icon {
		width: 20px;
        min-width: 20px;
		text-align: center;
        height: 20px;

        img {
            width: 20px;
            height: 20px;
        }
    }

    input {
        height: 20px;
        margin-left: 7px;
        flex: 1;
    }
}

.phone-item {
    padding: 0 !important;

    .country-code-btn {
        display: flex;
        align-items: center;
        padding: 0 4px 0 8px;
        cursor: pointer;
        white-space: nowrap;
        height: 100%;

        .country-flag {
            font-size: 16px;
            margin-right: 2px;
        }

        .country-dial {
            font-size: 14px;
            color: #333;
        }

        .arrow-down {
            font-size: 12px;
            color: #999;
            margin-left: 2px;
        }
    }

    .divider-line {
        width: 1px;
        height: 20px;
        background-color: #dfdfdf;
        margin: 0 6px;
        flex-shrink: 0;
    }

    input {
        height: 20px;
        flex: 1;
        margin-left: 0;
    }
}

.item_reset_pwd {
    font-size: 14px;
    color: #3d96ff;
    text-align: right;
    margin-top: 10px;
    line-height: 20px;
}
.van-checkbox{
	margin-top: 20px;
}
/deep/ .van-checkbox__icon--checked .van-icon {
    color: #fff;
    background-color: #ff5a50;
    border-color: #ff5a50;
}
/deep/ .van-checkbox__label{
	color: #ff5a50;
}
.reset_pwd{
	color: #333;
	margin-top: -20px;
	display: block;
}

.basic_btn {
    margin: 30px auto 0 auto;
}
.lan-label{
	display: flex;
	align-items: center;
	white-space: nowrap;
	height: 48px;
	min-width: 24px;
	height: 25px;
	padding-right: 8px;
	border-radius: 25px;
	background-image: linear-gradient(to right, #ffff80 , #ffffff);
}
.lan-label span{
	display: inline-block;
	margin-left: 3px;
}
.lan-label img{
	width: 22px;
	height: 22px;
}
.kefu-link{
	padding: 20px;
	text-align: center;
}
.kefu-link img{
	width: 35px;
}
.show-body{
	padding: 30px 30px 15px 30px;
	text-align: center;
}
</style>
<style>
	.van-popover{
		width:120px;
	}
	.van-popover__action{
		height: 40px;
		line-height: 40px;
	}
	.van-popover .van-popover__action-text::after{
		left: -100px;
	}
	.van-popover__action-icon{
		border: 1px solid #ececec;
		border-radius: 30px;
	}
	.van-popover__action{
		padding: 0 10px;
	}
	.country-search {
		padding: 8px 12px;
		background: #fff;
		border-bottom: 1px solid #f2f2f2;
	}
	.country-search-input {
		width: 100%;
		height: 34px;
		background: #f5f5f5;
		border: none;
		border-radius: 6px;
		padding: 0 12px;
		font-size: 14px;
		color: #333;
		box-sizing: border-box;
		outline: none;
	}
	.country-search-input::placeholder {
		color: #bbb;
	}
	.country-popup {
		border-radius: 12px 12px 0 0;
		overflow: hidden;
	}
	.country-picker-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 14px 16px 12px;
		font-size: 15px;
		font-weight: 500;
		color: #333;
		border-bottom: 1px solid #f2f2f2;
	}
	.cp-close {
		font-size: 18px;
		color: #bbb;
		cursor: pointer;
		padding: 0 4px;
		line-height: 1;
	}
	.country-list {
		max-height: 55vh;
		overflow-y: auto;
		-webkit-overflow-scrolling: touch;
	}
	.country-item {
		display: flex;
		align-items: center;
		padding: 12px 16px;
		border-bottom: 1px solid #f5f5f5;
		cursor: pointer;
	}
	.country-item--active {
		background-color: #fff8f7;
	}
	.ci-flag {
		font-size: 20px;
		width: 30px;
		flex-shrink: 0;
	}
	.ci-name {
		flex: 1;
		font-size: 14px;
		color: #333;
	}
	.ci-code {
		font-size: 14px;
		color: #888;
		margin-right: 6px;
	}
	.ci-check {
		color: #f12211;
		font-size: 15px;
		font-weight: bold;
	}
</style>
